module.exports = __webpack_public_path__ + "img/GENERALI_CHINA.75f85e31.jpg";